import HAppRoutes from '../../routes/helpers/HAppRoutes';
import IAppNavigation from '../interfaces/IAppNavigation';

class HAppNavigation {
	// Returns a new array of new items — does not mutate input. Caller can pass the
	// original config directly (no cloneDeep needed), which avoids deep-cloning JSX icons.
	static updateNavigationActive = (
		navigationConfig: IAppNavigation[],
		locationPathname: string,
	): IAppNavigation[] => {
		return navigationConfig.map((item) => {
			const routePath = HAppRoutes.getPath(item.routeTag ?? '', item.routeParams ?? null);
			const isActive = !!routePath && locationPathname.slice(0, routePath.length) === routePath;
			const children = item.children
				? HAppNavigation.updateNavigationActive(item.children, locationPathname)
				: item.children;
			return { ...item, isActive, children };
		});
	};
}

export default HAppNavigation;
